
/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  PortfolioConstraintsResource,
  PortfolioInspirationItemResource,
  PortfolioItemCreateRequest,
  PortfolioItemReportRequest,
  PortfolioItemResource,
  PortfolioItemSummaryResource,
  PortfolioItemUpdateRequest,
  SimpleError,
} from '../models';
import {
    PortfolioConstraintsResourceFromJSON,
    PortfolioConstraintsResourceToJSON,
    PortfolioInspirationItemResourceFromJSON,
    PortfolioInspirationItemResourceToJSON,
    PortfolioItemCreateRequestFromJSON,
    PortfolioItemCreateRequestToJSON,
    PortfolioItemReportRequestFromJSON,
    PortfolioItemReportRequestToJSON,
    PortfolioItemResourceFromJSON,
    PortfolioItemResourceToJSON,
    PortfolioItemSummaryResourceFromJSON,
    PortfolioItemSummaryResourceToJSON,
    PortfolioItemUpdateRequestFromJSON,
    PortfolioItemUpdateRequestToJSON,
    SimpleErrorFromJSON,
    SimpleErrorToJSON,
} from '../models';

export interface CreatePortfolioItemRequest {
    data: PortfolioItemCreateRequest;
    images?: Array<Blob> | null;
    thumbnail?: Blob | null;
}

export interface DeletePortfolioItemByIdRequest {
    id: string;
}

export interface GetPortfolioItemByIdRequest {
    id: string;
}

export interface ListPortfolioItemsRequest {
    profileId: string;
    publishedOnly: boolean;
}

export interface ReorderPortfolioItemsRequest {
    requestBody: Array<string>;
}

export interface ReportPortfolioItemByIdRequest {
    id: string;
    portfolioItemReportRequest: PortfolioItemReportRequest;
}

export interface UpdatePortfolioItemByIdRequest {
    id: string;
    data: PortfolioItemUpdateRequest;
    images?: Array<Blob> | null;
    thumbnail?: Blob | null;
}

/**
 * 
 */
export class PortfolioItemsApi extends runtime.BaseAPI {

    /**
     * Creates a new portfolio item
          */
    async createPortfolioItemRaw(requestParameters: CreatePortfolioItemRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<PortfolioItemResource>> {
        if (requestParameters['data'] == null) {
            throw new runtime.RequiredError(
                'data',
                'Required parameter "data" was null or undefined when calling createPortfolioItem().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['data'] != null) {
            formParams.append('data', new Blob([JSON.stringify(PortfolioItemCreateRequestToJSON(requestParameters['data']))], { type: "application/json", }));
                    }

        if (requestParameters['images'] != null) {
            requestParameters['images'].forEach((element) => {
                formParams.append('images', element as any);
            })
        }

        if (requestParameters['thumbnail'] != null) {
            formParams.append('thumbnail', requestParameters['thumbnail'] as any);
        }

        const response = await this.request<PortfolioItemResource>({
            path: `/profile/api/profiles/portfolios`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        if (response._data) { response._data=PortfolioItemResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Creates a new portfolio item
          */
    async createPortfolioItem(requestParameters: CreatePortfolioItemRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<PortfolioItemResource> {
        const response = await this.createPortfolioItemRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Deletes a portfolio item
          */
    async deletePortfolioItemByIdRaw(requestParameters: DeletePortfolioItemByIdRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deletePortfolioItemById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/profile/api/profiles/portfolios/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Deletes a portfolio item
          */
    async deletePortfolioItemById(requestParameters: DeletePortfolioItemByIdRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.deletePortfolioItemByIdRaw(requestParameters, initOverrides);
    }

    /**
     * Returns validation constraints for portfolio content (image size, blocked link hosts)
          */
    async getPortfolioConstraintsRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<PortfolioConstraintsResource>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<PortfolioConstraintsResource>({
            path: `/profile/api/profiles/portfolios/constraints`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=PortfolioConstraintsResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Returns validation constraints for portfolio content (image size, blocked link hosts)
          */
    async getPortfolioConstraints(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<PortfolioConstraintsResource> {
        const response = await this.getPortfolioConstraintsRaw(initOverrides);
        return response._data;
    }

    /**
     * Gets a portfolio item by id
          */
    async getPortfolioItemByIdRaw(requestParameters: GetPortfolioItemByIdRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<PortfolioItemResource>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getPortfolioItemById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<PortfolioItemResource>({
            path: `/profile/api/profiles/portfolios/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=PortfolioItemResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Gets a portfolio item by id
          */
    async getPortfolioItemById(requestParameters: GetPortfolioItemByIdRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<PortfolioItemResource> {
        const response = await this.getPortfolioItemByIdRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Returns a curated list of published portfolio items from various freelancers for inspiration
          */
    async listInspirationPortfolioItemsRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<PortfolioInspirationItemResource>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<PortfolioInspirationItemResource>>({
            path: `/profile/api/profiles/portfolios/inspiration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        response._data=response._data?.map(PortfolioInspirationItemResourceFromJSON);
        return response;
    }

    /**
     * Returns a curated list of published portfolio items from various freelancers for inspiration
          */
    async listInspirationPortfolioItems(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<PortfolioInspirationItemResource>> {
        const response = await this.listInspirationPortfolioItemsRaw(initOverrides);
        return response._data;
    }

    /**
     * Gets portfolio items
          */
    async listPortfolioItemsRaw(requestParameters: ListPortfolioItemsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<PortfolioItemSummaryResource>>> {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError(
                'profileId',
                'Required parameter "profileId" was null or undefined when calling listPortfolioItems().'
            );
        }

        if (requestParameters['publishedOnly'] == null) {
            throw new runtime.RequiredError(
                'publishedOnly',
                'Required parameter "publishedOnly" was null or undefined when calling listPortfolioItems().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['publishedOnly'] != null) {
            queryParameters['publishedOnly'] = requestParameters['publishedOnly'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<PortfolioItemSummaryResource>>({
            path: `/profile/api/profiles/{profileId}/portfolios`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        response._data=response._data?.map(PortfolioItemSummaryResourceFromJSON);
        return response;
    }

    /**
     * Gets portfolio items
          */
    async listPortfolioItems(requestParameters: ListPortfolioItemsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<PortfolioItemSummaryResource>> {
        const response = await this.listPortfolioItemsRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Reorders portfolio items by providing the ordered list of item ids
          */
    async reorderPortfolioItemsRaw(requestParameters: ReorderPortfolioItemsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling reorderPortfolioItems().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/profile/api/profiles/portfolios/order`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return response;
    }

    /**
     * Reorders portfolio items by providing the ordered list of item ids
          */
    async reorderPortfolioItems(requestParameters: ReorderPortfolioItemsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.reorderPortfolioItemsRaw(requestParameters, initOverrides);
    }

    /**
     * Submit a report for a portfolio item
          */
    async reportPortfolioItemByIdRaw(requestParameters: ReportPortfolioItemByIdRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling reportPortfolioItemById().'
            );
        }

        if (requestParameters['portfolioItemReportRequest'] == null) {
            throw new runtime.RequiredError(
                'portfolioItemReportRequest',
                'Required parameter "portfolioItemReportRequest" was null or undefined when calling reportPortfolioItemById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/profile/api/profiles/portfolios/{id}/report`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PortfolioItemReportRequestToJSON(requestParameters['portfolioItemReportRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Submit a report for a portfolio item
          */
    async reportPortfolioItemById(requestParameters: ReportPortfolioItemByIdRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.reportPortfolioItemByIdRaw(requestParameters, initOverrides);
    }

    /**
     * Updates a portfolio item — full replacement of content blocks
          */
    async updatePortfolioItemByIdRaw(requestParameters: UpdatePortfolioItemByIdRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<PortfolioItemResource>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updatePortfolioItemById().'
            );
        }

        if (requestParameters['data'] == null) {
            throw new runtime.RequiredError(
                'data',
                'Required parameter "data" was null or undefined when calling updatePortfolioItemById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['data'] != null) {
            formParams.append('data', new Blob([JSON.stringify(PortfolioItemUpdateRequestToJSON(requestParameters['data']))], { type: "application/json", }));
                    }

        if (requestParameters['images'] != null) {
            requestParameters['images'].forEach((element) => {
                formParams.append('images', element as any);
            })
        }

        if (requestParameters['thumbnail'] != null) {
            formParams.append('thumbnail', requestParameters['thumbnail'] as any);
        }

        const response = await this.request<PortfolioItemResource>({
            path: `/profile/api/profiles/portfolios/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        if (response._data) { response._data=PortfolioItemResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Updates a portfolio item — full replacement of content blocks
          */
    async updatePortfolioItemById(requestParameters: UpdatePortfolioItemByIdRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<PortfolioItemResource> {
        const response = await this.updatePortfolioItemByIdRaw(requestParameters, initOverrides);
        return response._data;
    }

}
